import fs from 'node:fs'
import type { ResolvedBetterstartConfig } from '@cli-types/core-engine/config.js'
import { getEmailTemplatesDir } from './get-email-templates-dir.js'

export function removeEmailTemplatesDirIfEmpty(
  cwd: string,
  config: ResolvedBetterstartConfig
): void {
  const dir = getEmailTemplatesDir(cwd, config)
  if (!fs.existsSync(dir)) return

  if (fs.readdirSync(dir).length === 0) {
    fs.rmdirSync(dir)
  }
}
